import { Input } from "antd"
import _ from 'lodash';
import "./index.scss";

const CustomInput = props => {
    const inheritedProps = _.pick(props, ['id','invalid', 'value', 'onChange', 'placeholder', 'autofill', 'prefix'])
    return (
        <Input className={`input ${props.className || ""} ${inheritedProps.invalid ? 'invalid' : ''}`} {...inheritedProps} />
    )
}

export default CustomInput;